import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../../../../theming/useTheme';
import { footerSectionPadding } from '../footer.utils';
import { TextLinkComponent } from '../../../../partials/link/TextLink';
import { H4, semanticCSS } from '../../../../../typography/semanticTags';
import { BaseUnit } from '../../../../../theming/baseUnitDefinition';

const componentConfigurationKey = 'footerSocialLinks';

export interface SocialLink {
  href: string;
  src: string;
  alt: string;
}
export interface SocialSectionDataProps {
  title: string;
  imageLinks: SocialLink[];
}

interface SocialLinksThemeProps {
  baseUnit: BaseUnit;
  titleColor: string;
  circleColor: string;
}

const getSocialLinksStyle = (baseUnit: BaseUnit, titleColor: string, circleColor: string, numberOfColumns: number) => {
  const padding = footerSectionPadding(baseUnit);

  return StyleSheet.create({
    section: {
      ...padding,
    },
    title: {
      textAlign: 'center',
      color: titleColor,
    },
    storesWrapper: {
      display: 'grid',
      gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)`,
      gridGap: `${baseUnit * 0.5}px`,
      marginTop: `${baseUnit * 0.5}px`,
    },
    circle: {
      width: '40px',
      height: '40px',
      backgroundColor: circleColor,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  });
};

const createStoreItem = (circleStyle: object) => (socialLink: SocialLink, index: number) => {
  return (
    <TextLinkComponent href={socialLink.href} key={index} rel="noopener" target="_blank">
      <div className={css(circleStyle)}>
        <img alt={socialLink.alt} src={socialLink.src} height="16" />
      </div>
    </TextLinkComponent>
  );
};

const maxSocialItemsPerRow = 5;

export const FooterSocialLinks = (props: SocialSectionDataProps) => {
  const { title, imageLinks } = props;
  const { baseUnit, titleColor, circleColor } = useTheme<SocialLinksThemeProps>(componentConfigurationKey);
  const style = getSocialLinksStyle(baseUnit, titleColor, circleColor, Math.min(imageLinks.length, maxSocialItemsPerRow));
  return (
    <div className={css(style.section)}>
      <H4 styles={semanticCSS(style.title)}>{title}</H4>
      <div className={css(style.storesWrapper)}>
        {imageLinks.map(createStoreItem(style.circle))}
      </div>
    </div>
  );
};
